import { baseApi } from '@/lib';

import { SettlementImport, SettlementImportsResponse } from '../types';

interface GetSettlementImportsParams {
  month?: number;
  year?: number;
}

const enhancedApi = baseApi.enhanceEndpoints({
  addTagTypes: ['SettlementImports'],
});

export const settlementImportsApi = enhancedApi.injectEndpoints({
  endpoints: (builder) => ({
    getSettlementImports: builder.query<SettlementImportsResponse, GetSettlementImportsParams>({
      query: (params) => ({
        url: 'settlement-imports',
        params,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.items.map((item) => ({
                type: 'SettlementImports' as const,
                id: item.id,
              })),
              { type: 'SettlementImports', id: 'LIST' },
            ]
          : [{ type: 'SettlementImports', id: 'LIST' }],
    }),
    uploadSettlementImport: builder.mutation<SettlementImport, FormData>({
      query: (formData) => ({
        url: 'settlement-imports/upload',
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: [{ type: 'SettlementImports', id: 'LIST' }],
    }),
    deleteSettlementImport: builder.mutation<void, string>({
      query: (id) => ({
        url: `settlement-imports/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, id) => [
        { type: 'SettlementImports', id },
        { type: 'SettlementImports', id: 'LIST' },
      ],
    }),
  }),
});

export const {
  useGetSettlementImportsQuery,
  useUploadSettlementImportMutation,
  useDeleteSettlementImportMutation,
} = settlementImportsApi;
